import { Injectable } from '@angular/core';
import { Permissions } from '../enums/permissions.enum';

const STORAGE_KEY = 'user_permissions';

const isBrowser = typeof localStorage !== 'undefined';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private permissions: Permissions[] = [];

  constructor() {
    this.loadFromStorage();
  }

  setPermissions(permissions: Permissions[]): void {
    this.permissions = permissions;
    if (isBrowser) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(permissions));
    }
  }

  clearPermissions(): void {
    this.permissions = [];
    if (isBrowser) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  has(permission: Permissions): boolean {
    return this.permissions.includes(permission);
  }

  hasAny(perms: Permissions[]): boolean {
    return perms.some((p) => this.permissions.includes(p));
  }

  isDoctor(): boolean {
    if (!isBrowser) return false;
    const stored = localStorage.getItem('availableUserRoles');
    if (!stored) return false;
    try {
      const roles: string[] = JSON.parse(stored);
      return roles.includes('DOCTOR');
    } catch {
      return false;
    }
  }

  isManager(): boolean {
    if (!isBrowser) return false;
    const stored = localStorage.getItem('availableUserRoles');
    if (!stored) return false;
    try {
      const roles: string[] = JSON.parse(stored);
      return roles.includes('MANAGER');
    } catch {
      return false;
    }
  }

  isReception(): boolean {
    if (!isBrowser) return false;
    const stored = localStorage.getItem('availableUserRoles');
    if (!stored) return false;
    try {
      const roles: string[] = JSON.parse(stored);
      return roles.includes('RECEPTION');
    } catch {
      return false;
    }
  }

  getAvailableRoles(): string[] {
    if (!isBrowser) return [];
    const stored = localStorage.getItem('availableUserRoles');
    if (!stored) return [];
    try {
      return JSON.parse(stored) as string[];
    } catch {
      return [];
    }
  }

  getActiveRole(): string | null {
    if (!isBrowser) return null;
    const role = localStorage.getItem('userRole');
    return role ? role : null;
  }

  private loadFromStorage(): void {
    if (!isBrowser) return;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        this.permissions = JSON.parse(stored) as Permissions[];
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }
}
